import {
	orderBy
} from 'lodash'

export default {
	todos(state) {
		return orderBy(state.todos, ['id'], ['desc'])
	},
	questions(state) {
		return state.questions;
	},
	lang(state) {
		return state.lang;
	}

}